<template lang="html">
	<div class="upload_wrap">
		<el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="fnUploadRequest" :before-upload="before_upload">
			<img v-if="value" :src="match(value)" class="avatar">
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>
<script>
import { uploadOSS,deleteOSS } from '@/utils/oss';
import {matchType} from '@/utils/matchType.js'
export default {
	name: 'upload_image',
	data() {
		return {
			loading:null,
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		file_name: {
			type: String,
			default: 'image' //file video
		}
	},
	methods: {
		async fnUploadRequest(options){
			try {
				let file = options.file;
				var date = new Date();
				var y = date.getFullYear();
				var m = date.getMonth()+1;
				var d = date.getDate();
				var timestamp = date.getTime();
				let res = await uploadOSS(this.file_name+'/'+(y+''+(m<10?'0'+m:m)+''+(d<10?'0'+d:d))+'/'+timestamp+file.name,file);
	            this.$emit('callback', res);
				this.$message.success("上传成功！");
				this.loading.close();
			} catch (e) {
				this.$message.error('上传失败！');
				this.loading.close();
			}
		},
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		match(data){
			var name = matchType(data);
			if(name=='image'){
				return data
			}else{
				return require('@/assets/img/doctype/icon-'+name+'.svg');
			}
		}
	}
}
</script>
<style lang="css">
.upload_wrap .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.upload_wrap .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.upload_wrap .avatar-uploader .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.upload_wrap .avatar-uploader .avatar-uploader-icon {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue